<div class="container">
  <div class="first-section">
    <div class="header-container">
      <span class="heading first">Product Variable Name</span>
      <i class="material-icons close-icon" (click)="closeViewJSONDialog()">close</i>
    </div>
  </div>
  <div class="section">
    <mat-dialog-content>
      <div class="view-json-container mb-3 mt-3" [ngClass]="{'hide': mode === 'edit'}">
        <div class="json-label mb-2">
          <hansel-tag tagType="value" tagTxt="JSON"></hansel-tag>
          {{data.key}}
        </div>
        <div class="json-container"></div>
        <div class="json-hint mt-2 ml-2"><span (click)="editJson()">Edit
            JSON</span></div>
      </div>

      <div class="edit-json-container" style="width: 100%" *ngIf="mode !== 'view'">
        <div class="json-label mb-2">
          <hansel-tag tagType="value" tagTxt="JSON"></hansel-tag>
          {{data.key}}
        </div>
        <div ace-editor [(text)]="JSONValue" [mode]="'json'" [theme]="'chrome'" [readOnly]="false"
          [autoUpdateContent]="true" style="width: 100%; min-height: 200px; overflow: auto; border: 1px solid #ededed;">
        </div>
        <div class="json-hint mt-2 ml-2"><span (click)="viewJson()">View
            JSON</span></div>
      </div>
    </mat-dialog-content>
  </div>
  <div class=" footer" *ngIf="mode === 'edit' && data.showEditBtn">
    <button class="primary-btn done-btn" mat-flat-button [promiseBtn]="btnPromise" (click)="onUpdate()">Update</button>
  </div>
</div>
